<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card flat>
                <v-card-title>
                    {{ title }}
                    <v-spacer></v-spacer>
                    <v-switch
                        :label="$t('mini_mode')"
                        v-model="mode.mini">
                    </v-switch>
                </v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form
                        v-model="valid"
                        ref="form">
                        <v-text-field
                            :disabled="uneditableField('first_name')"
                            v-model="form.first_name"
                            :rules="rules.first_name"
                            :label="$t('first_name')">
                        </v-text-field>
                        <v-text-field
                            :disabled="uneditableField('last_name')"
                            v-model="form.last_name"
                            :rules="rules.last_name"
                            :label="$t('last_name')">
                        </v-text-field>
                        <v-text-field
                            v-if="!mode.mini"
                            :disabled="uneditableField('email')"
                            v-model="form.email"
                            :rules="rules.email"
                            :label="$t('email')">
                        </v-text-field>
                        <v-text-field
                            v-if="!mode.mini"
                            :disabled="uneditableField('phone')"
                            v-model="form.phone"
                            :label="$t('phone')">
                        </v-text-field>
                        <v-text-field
                            :disabled="uneditableField('username') || mode.edit"
                            v-model="form.username"
                            :rules="rules.username"
                            :label="$t('username')">
                        </v-text-field>
                        <v-switch
                            label="Must Change Password"
                            v-model="form.must_change_password"
                            ></v-switch>
                        <v-switch
                            v-if="mode.edit"
                            :label="$t('change_password')"
                            @change="clearField"
                            v-model="editPassword">
                        </v-switch>
                        <v-text-field
                            v-if="editPassword"
                            type="password"
                            :disabled="uneditableField('password')"
                            v-model="form.password"
                            :rules="rules.password"
                            :label="$t('password')">
                        </v-text-field>
                        <v-text-field
                            v-if="editPassword"
                            type="password"
                            :disabled="uneditableField('password_confirmation')"
                            v-model="form.password_confirmation"
                            :rules="rules.password_confirmation"
                            :label="$t('confirm_password')">
                        </v-text-field>
                        <v-switch
                            v-if="mode.edit"
                            :label="$t('deactivate')"
                            v-model="form.inactive">
                        </v-switch>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn 
                        :loading="loading.submit"
                        :disabled="!valid"
                        @click="submit" 
                        text>
                        {{ $t('save_btn') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <AlertDialog 
            ref="alertDialog"/>
    </div>
</template>
<script>
import uneditableField from '@/utils/uneditableField';
import AlertDialog from '@/components/common/AlertDialog'
import RetryDialog from '@/components/common/RetryDialog';
import { mapActions, mapState } from 'vuex';
export default {
    name: "UserDailog",
    components: {
        RetryDialog,
        AlertDialog
    },
    data() {
        return {
            display: false,
            openParams: null,
            valid: false,
            editPassword: true,
            loading: {
                data: false,
                submit: false
            },
            mode: { 
                edit: false,
                mini: false
            },
            form: {
                id: null,
                inactive: null,
                first_name: null,
                last_name: null,
                username: null,
                password: null,
                phone: null,
                email: null,
                password_confirmation: null,
                must_change_password: false
            },
            rules: {
                first_name: [
                    v => !!v || this.$t('rules_required')
                ],
                last_name: [
                    v => !!v || this.$t('rules_required')
                ], 
                username: [
                    v => !!v || this.$t('rules_required') 
                ],
                password: [
                    v => !!v || this.$t('rules_required')
                ],
                password_confirmation: [
                    v => !!v || this.$t('rules_required'),
                    v => v == this.form.password || this.$t("PASS_CONF_MISMAT_MSG")
                ]
            }
            
        }
    },
    computed: {
        ...mapState('administration/user', ["user"]),
        title() {
            if(!this.mode.edit) return this.$t('new_user')
            else return this.$t('edit_user')
        }
    },
    methods: {
        uneditableField,
        ...mapActions('administration/user',["fetchUser", "storeUser", "updateUser"]),
        open(params) {
            this.mode.edit = params.editMode;
            this.openParams = params;
            this.loading.data = true;
            this.openDataFetch();
            this.display = true;
        },
        async openDataFetch() {
            try {
                if(this.mode.edit) {
                    this.editPassword = false;
                    await this.fetchUser(this.openParams.id);
                    this.form = JSON.parse(JSON.stringify(this.user));
                }
                this.loading.data = false
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        onRetryDialogSubmit(params) {
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
                else this.close();
            }
        },
        clearField() {
            this.form.password = null;
            this.form.password_confirmation = null;
        },
        submit() {
            this.loading.submit = true;
            if(!this.mode.edit) {
                this.storeUser(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.$refs.alertDialog.open({type: "success", message: this.$t("record_save_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            } else {
                this.updateUser(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.$refs.alertDialog.open({type: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});

                    })
            }
        },
        close() {
           Object.assign(this.$data, this.$options.data.apply(this))
        }
    },
}
</script>